import { format } from 'date-fns';
import { MonthAvailability } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { areAllWeekdaysSelected } from 'src/components/oneCorp/features/MealCredit/utils/areAllWeekdaysSelected';
import { MealCreditInfoTextProps } from 'src/components/oneCorp/features/MealCredit/utils/constructMealCreditInfoText.utils';
import { getMonthAvailableDaysCount } from 'src/components/oneCorp/features/MealCredit/utils/getMonthAvailableDaysCount';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';

export function getMonthMealCreditText(
  props: Pick<
    MealCreditInfoTextProps,
    | 'isRepeating'
    | 'monthAvailableOn'
    | 'monthAvailableTo'
    | 'startDate'
    | 'selectedDays'
    | 'timeIntervalType'
  >
): string {
  const {
    isRepeating,
    monthAvailableOn,
    monthAvailableTo,
    startDate,
    selectedDays,
    timeIntervalType,
  } = props;

  const connectingTextRepeat = isRepeating ? 'each' : 'the';
  const formattedMonthStart = format(startDate, 'do');

  if (monthAvailableOn === MonthAvailability.ON_SPECIFIC_DAY) {
    return ` on the ${formattedMonthStart} of ${connectingTextRepeat} month`;
  }

  if (
    monthAvailableOn === MonthAvailability.WITHIN_DATE_RANGE &&
    monthAvailableTo
  ) {
    const daysCount = getMonthAvailableDaysCount({
      startDate,
      monthAvailableTo,
      timeIntervalType,
    });
    return ` during the ${daysCount} ${getSingularOrPlural(
      daysCount,
      'day'
    )} starting from ${formattedMonthStart} of ${connectingTextRepeat} month`;
  }

  if (
    monthAvailableOn === MonthAvailability.EVERY_DAY &&
    areAllWeekdaysSelected({ selectedDays })
  ) {
    return '';
  }

  return ` of ${connectingTextRepeat} month`;
}
